import { ServiceFactory } from "./core/factory";
import TRTCLiveService from "./services/live/trtc/index";
import TIMIMService from "./services/im/tim/index";
import TIWboardService from "./services/whiteboard/tiw/index";
import defaultConfig from "../config/default.config";
const LiveSDK = {
  install(Vue, options = {}) {
    // // 合并配置
    // const config = { ...defaultConfig, ...options };
    // console.log(config);
    // // // 初始化服务工厂
    // const factory = new ServiceFactory(config);
    // factory.registerService(
    //   "live",
    //   "trtc",
    //   new TRTCLiveService(config.live.trtc)
    // );
    // // // 注册全局属性
    // return factory;
  },
  init(config = {}) {
    const serviceFactory = new ServiceFactory(config);
    const provider = config.providers;
    const live = config.live || {};
    const im = config.im || {};
    const whiteboard = config.whiteboard || {};
    console.log("platform>>>>>", provider);
    if (provider.im) {
      if (provider.im === "tim" && im.tim) {
        // 腾讯im
        serviceFactory.registerService(
          "im",
          provider.im,
          new TIMIMService(im.tim)
        );
      }
    }
    if (provider.live) {
      if (provider.live === "trtc" && live.trtc) {
        // 腾讯trtc
        serviceFactory.registerService(
          "live",
          provider.live,
          new TRTCLiveService(live.trtc)
        );
      }
    }
    if (provider.whiteboard) {
      if (provider.whiteboard === "tiw" && whiteboard.tiw) {
        serviceFactory.registerService(
          "whiteboard",
          provider.whiteboard,
          new TIWboardService(whiteboard.tiw)
        );
      }
    }

    return serviceFactory;
  },
};

export default LiveSDK;
